<template>
  <table>
    <tr><th v-for="(header, idx) in headers" :key="'point-th-'+idx">{{ header }}</th></tr>
    <tr v-for="(item,idx) in list" :key="'point-tr-'+idx">
      <td v-for="key in keys" :key="'td-'+key">
        <span v-if="key === 'created_time'">{{ datesFormat(item[key], 'date_4') }}</span>
        <span v-else-if="key.indexOf('point')>-1" :class="{'use-color': item[key] < 0}">{{ item[key]|currencyNum }}</span>
        <a v-else-if="key === 'order_num'" target="_blank" :href="`/office/admin/${item.package}/order/detail?id=${item.order_id}&page=OrderListPayAll`">{{ item[key] }}</a>
        <span v-else>{{ item[key] }}</span>
      </td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "PointTable",
    props: {
      list: {
        type: Array
      }
    },
    created() {
      if(this.$route.path.indexOf('review')>-1) {
        this.headers = ['유형', '내용', '금액', '일자', '처리자'];
        this.keys = ['type', 'content', 'point', 'created_time', 'manager']
      } else {
        this.headers = ['유형', '내용', '금액', '일자', '잔액', '관련 주문', '처리자'];
        this.keys = ['type', 'content', 'point', 'created_time', 'after_point', 'order_num', 'manager']
      }
    },
    data() {
      return {
        headers: [],
        keys: []
      }
    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>
  table, th, td
    border 1px solid #dddddd
  table
    width 100%

  th, td
    text-align center !important
    padding 8px
  th
    background-color #eeeeee
  .use-color
    color #ff0303
</style>
